export const getAvatarLetter = (name?: string | null) =>
  name && name.length > 0 ? name.trim().charAt(0) : '?';
